<template>
    <div class="h-100 d-flex flex-lg-column align-items-center align-items-lg-stretch justify-content-between mt-3 mt-lg-0">
        <div class="d-flex align-items-center justify-content-end">
            <b-dropdown right variant="plain"
                        v-if="hasDropdownSlot"
                        no-caret
                        lazy
                        toggle-class="p-0 d-flex align-items-center"
                        toggle-tag="span">
                <template v-slot:button-content>
                    <i class="fa-lg fas fa-ellipsis-h mr-2 cursor-pointer"/>
                </template>
                <slot name="dropdown-options"/>
            </b-dropdown>
            <i class="cursor-pointer"
               :class="{'ic-collapse': editing, 'ic-expand': !editing}"
               @click="$emit('editing')"
               v-if="!expanded"
            />
        </div>
        <div v-if="editing && !savingDisabled">
            <b-button variant="primary" class="btn-rounded" size="sm"
                      :disabled="saving"
                      @click="$emit('saveAsset')">
                <span v-if="saving">Saving...</span>
                <span v-else>Save</span>
            </b-button>
        </div>
    </div>
</template>

<script>
  export default {
    props: ['editing', 'saving', 'savingDisabled', 'dropdown', 'expanded'],
    computed: {
      hasDropdownSlot: function () {
        return !!this.$slots['dropdown-options']
      }
    }
  }
</script>